import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';
import { UtilityService } from '../utility/utility.service';

@Injectable({
  providedIn: 'root'
})
export class LeaveService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
    private utility: UtilityService,
  ) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  LoadEmployeeLeaveCombo(Detail: any):Observable<any> {
    return this.utility.callWithRetry('LoadEmployeeLeave/LoadEmployeeLeaveCombo', Detail);
    // return this.http.post<any>(environment.API_URL + `LoadEmployeeLeave/LoadEmployeeLeaveCombo`,
    //   this.session.SetClass(Detail)
    // ).pipe(map(response => {
    //   if (response.Error_Code == '11' || response.Error_Code == '02') {
    //     this.session.End();
    //   } else {
    //     return response;
    //   }
    // }));
  }

  SaveEmployeeLeaveDetails(Detail: any) {
    return this.http.post<any>(environment.API_URL + `EmployeeLeaveDetails/Save`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GetEmployeeLeaveDetails(Detail: any) {
    return this.http.post<any>(environment.API_URL + `Load/EmployeeLeaveDetails`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESSLeavePolicyInsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LeavePolicy_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESSLeavePolicySelectGet(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LeavePolicy_Select/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmployeeLeaveWithdrawLoad(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeLeaveWithdraw/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_LoadLeaveApprovalDetailsApp(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LoadLeaveApprovalDetails/App`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_LeaveDualApplicabilitySelect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LeaveDualApplicability/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_LeaveDualApplicability_InsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LeaveDualApplicability_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
